import { Injectable, inject } from '@angular/core';
import { HttpProviderService } from '../http-provider/http-provider.service';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { MobileService } from 'src/app/mobile.services';

export abstract class FpxFormControlErrorMessage {
  private _errorJsonObj: any;
  private _httpProvider: HttpClient = inject(HttpClient);

  public setErrorJson(jsonPath: string) {
    this._httpProvider.get(jsonPath).subscribe({
      next: (res: any) => {
        console.log(res);
        this.setErroMessage(res);
      },
      error: () => {},
      complete: () => {},
    });
  }

  public getErroMessage(): any {
    return this._errorJsonObj;
  }

  public setErroMessage(errorJson: any) {
    this._errorJsonObj = errorJson;
  }
}

@Injectable({
  providedIn:'root'
})
export class FPxFakeFormControlErrorMessageService extends FpxFormControlErrorMessage {
  constructor(private http: HttpClient,
    private mobileService: MobileService) {
    super();
    var origin = window.location.origin + window.location.pathname;
    if (this.mobileService.isHybrid()) {
      origin = "./";
    }
    const url = origin + "assets/i18n/val_en.json";
    this.setErrorJson(url);
  }

}
